import { add, isWithinInterval } from 'date-fns';

export default ({ agendaItem }) => {
  if (!agendaItem || !agendaItem.start_date) return false;

  const { start_date: startDate, start_time: startTime, duration } = agendaItem;

  // agenda items always returned as UTC
  const startAt = new Date(`${startDate}T${startTime}Z`);
  const endAt = add(startAt, {
    hours: duration.hour || 0,
    minutes: duration.minute || 0,
  });

  return isWithinInterval(new Date(), {
    start: startAt,
    end: endAt,
  });
};
